var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_755_15349)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_15349)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#05603A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_755_15349)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8514,
    cy: 15.0595,
    rx: 24.1463,
    ry: 23.7024,
    fill: "#32D583"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_755_15349)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6313,
    cy: 11.7858,
    rx: 14.7561,
    ry: 14.4048,
    fill: "#6CE9A6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_755_15349)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.2504,
    cy: 3.73998,
    rx: 6.2504,
    ry: 3.73998,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 20.1198 37.7187)",
    fill: "#12B76A"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.92 10.88V28.04C24.92 29.2667 25.16 30.0933 25.64 30.52C26.12 30.9467 26.9467 31.16 28.12 31.16V32C27.5867 31.9733 26.8 31.9467 25.76 31.92C24.7467 31.8667 23.6933 31.84 22.6 31.84C21.2667 31.84 19.9867 31.8667 18.76 31.92C17.56 31.9467 16.6267 31.9733 15.96 32V31.16C17.1867 31.16 18.1467 30.9467 18.84 30.52C19.5333 30.0667 19.88 29.1867 19.88 27.88V18.12C19.88 16.84 19.76 15.8933 19.52 15.28C19.28 14.6667 18.8533 14.2667 18.24 14.08C17.6267 13.8933 16.7867 13.8 15.72 13.8V12.92C17.88 12.8667 19.6667 12.6933 21.08 12.4C22.52 12.1067 23.8 11.6 24.92 10.88Z",
    fill: "#1D4D38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_755_15349",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.2771,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_755_15349"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0117647 0 0 0 0 0.596078 0 0 0 0 0.333333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_755_15349"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_755_15349",
    x: -20.2586,
    y: -24.6066,
    width: 80.2202,
    height: 79.3322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15349"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_755_15349",
    x: -14.0885,
    y: -18.5827,
    width: 61.4396,
    height: 60.737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15349"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_755_15349",
    x: 13.1469,
    y: 28.6889,
    width: 27.6895,
    height: 23.0326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83129,
    result: "effect1_foregroundBlur_755_15349"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_15349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/number1.47be6a0dc19fc03d7b04972875764f64.svg";
export { ForwardRef as ReactComponent };